import styled, { css } from 'styled-components';
import { borderRadius, fontStyle, get, mediaBreakpointUp, themeColor, buttonColor } from '@whitelabel/helpers/style';

const activeScoreCSS = css`
  background-color: ${themeColor('primary')};
  border-color: ${themeColor('primary')};
`;

export const StyledTitle = styled.h3`
  text-transform: none;
  ${fontStyle('h5')}
`;

export const StyledScore = styled.li<{ $selected: boolean }>`
  margin-bottom: 0.5rem;
  border: ${get('borderStyle')};
  border-radius: ${borderRadius('base')};

  width: 100%;
  padding: 0.5rem 0;
  text-align: center;
  cursor: pointer;
  ${fontStyle('button')}
  &:hover {
    ${activeScoreCSS}
  }

  ${({ $selected }) =>
    $selected &&
    css`
      &&& {
        display: list-item;
        color: ${themeColor('dark')};
        ${activeScoreCSS}
      }
    `}
`;

export const StyledScoreList = styled.ol`
  width: 100%;
  margin-bottom: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column-reverse;
  ${mediaBreakpointUp('sm')`
    margin-bottom: 1rem;
    flex-direction: unset;
  `}
`;

export const StyledScoreWrapper = styled.div<{ $scoreSelected: boolean }>`
  .negative {
    margin-bottom: 0;
  }
  .positive {
    margin-bottom: 0.5rem;
  }

  display: flex;
  flex-direction: column-reverse;

  ${mediaBreakpointUp('sm')`
    display: flex;
    flex-direction: unset;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    ${StyledScoreList} {
      order: 1;
      flex: 1 0 100%;
      display: flex;
    }

    ${StyledScore} {
      margin-bottom: 0;
      padding: 1rem 0;
      &:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      &:not(:last-child) {
        border-right-width: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    .negative {
      order: 2;    
    }
    .positive {
      order: 3;
    }
  `}

  p {
    color: ${themeColor('subtext')};
    text-align: center;
    ${mediaBreakpointUp('sm')`
      display: inline-block;
      margin-bottom: 0;
    `}
  }

  ${({ $scoreSelected }) =>
    $scoreSelected &&
    css`
      ${StyledScore} {
        display: none;
        margin-bottom: 0;
        pointer-events: none;
        user-select: text;
        color: ${buttonColor('secondary', 'label', 'disabled')};
        border-color: ${buttonColor('secondary', 'outline', 'disabled')};
        ${mediaBreakpointUp('sm')`
          display: list-item;
        `}
      }
      p {
        display: none;
        ${mediaBreakpointUp('sm')`
          display: inline-block;
        `}
      }
    `}
`;

export const StyledAdditionalBlock = styled.div`
  flex: 1 0 100%;
  order: 4;

  p {
    color: ${themeColor('subtext')};
  }
`;

export const StyledMainWrapper = styled.div`
  padding: 1rem;
  border: ${get('borderStyle')};
  ${mediaBreakpointUp('sm')`
    padding: 1.5rem;
  `}

  ${mediaBreakpointUp('lg')`
    padding: 2rem;
  `}
`;
